import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import { isEmpty, map, find, filter, forEach, compact, concat } from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";
import Button from "react-md/lib/Buttons/Button";
import FontIcon from "react-md/lib/FontIcons";
import Avatar from "react-md/lib/Avatars";

import AutocompleteField from "../../form/AutocompleteField";
import * as Validation from "../../form/Validation";
import List from "./List";

import { setActiveForm } from "../../../actions/appActions";
import { getTypeBySearch } from "../../../actions/resourceActions";
import {
  updateOrganizationNormal,
  getOrganizationNormal
} from "../../../actions/resourceActions";
import { setDialog } from "../../../actions/dialogActions";
import {DebugElement} from "../../../Atollon/debug";

const userAvatar = <Avatar icon={<FontIcon>person</FontIcon>} suffix="black" />;

const Administrators = ({
  handleSubmit,
  activeForm,
  setActiveForm,
  items,
  organization,
  updateOrganizationNormal,
  getOrganizationNormal,
  users,
  setAutocompleteContent,
  getTypeBySearch,
  change,
  setDialog
}) => {
  const optionsAutocomplete = [];
  if (users)
    forEach(users.item, item =>
      optionsAutocomplete.push({
        label: `${item.name
          ? `${item.name} (`
          : ""}${item.identifier}${item.name ? `)` : ""}`,
        value: item.identifier
      })
    );
  return (
    <Card className="card">
        <DebugElement text={"src/components/settings/organizationEdit/Administrators.js"}/>
      <CardTitle title="SPRÁVCI" />
      {items && !isEmpty(items) ? (
        <CardText className="padding-none">
          <List
            items={map(items, item => {
              return {
                primary: item.name,
                secondary: item.identifier,
                onClick: () => {
                  setDialog("DeleteRelatedResource", {
                    title: `Jste si jist(á), že chcete odstranit správce ${item.name
                      ? `${item.name} (${item.identifier})`
                      : item.identifier}?`,
                    text:
                      "Uživatel nebude moci nadále spravovat tuto organizaci.",
                    resource: {
                      ...organization,
                      relatedResources: filter(
                        organization.relatedResources,
                        type =>
                          type.identifier !== item.identifier &&
                          type.role === item.role
                      )
                    },
                    onSubmit: () =>
                      getOrganizationNormal(organization.identifier)
                  });
                }
              };
            })}
            leftAvatar={userAvatar}
          />
        </CardText>
      ) : (
        <div />
      )}
      <CardText>
        {activeForm === "organizationAdministrators" ? (
          <form onSubmit={handleSubmit}>
            <div className="flex-col">
              <Field
                component={AutocompleteField}
                label="Email"
                name="identifier"
                data={optionsAutocomplete}
                onChange={(e, value) => getTypeBySearch("PERSON", value, true)}
                onAutocomplete={value => {
                  if (find(users.item, u => u.identifier === value)) {
                    change("identifier", value);
                  }
                }}
                validate={[Validation.required]}
              />
            </div>
            <div className="flex-row flex-right">
              <Button
                raised
                className="btn"
                label="Cancel"
                onClick={() => setActiveForm(null)}
              />
              <Button
                raised
                className="btn btn-primary"
                label="Přidat"
                type="submit"
              />
            </div>
          </form>
        ) : (
          <Button
            raised
            className="btn btn-primary"
            label="Přidat nového správce"
            onClick={() => setActiveForm("organizationAdministrators")}
          />
        )}
      </CardText>
    </Card>
  );
};

export default compose(
  connect(
    ({ app: { form: { activeForm } }, resource: { users } }) => ({
      activeForm,
      users
    }),
    {
      setActiveForm,
      getTypeBySearch,
      updateOrganizationNormal,
      getOrganizationNormal,
      setDialog
    }
  ),
  withHandlers({
    onSubmit: ({
      updateOrganizationNormal,
      organization,
      setActiveForm,
      getOrganizationNormal,
      users
    }) => async (formData, dispatch, props) => {
      const { identifier } = formData;

      const selectedUser = find(users.item, u => u.identifier === identifier);

      if (!selectedUser) {
        throw new SubmissionError({
          identifier: "Špatný email."
        });
      }

      if (
        await updateOrganizationNormal({
          ...organization,
          relatedResources: compact(
            concat(organization.relatedResources, {
              ...selectedUser,
              role: "ADMIN"
            })
          )
        })
      ) {
        getOrganizationNormal(organization.identifier);
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          identifier: "Pozvání se nezdařilo."
        });
      }
    }
  }),
  reduxForm({ form: "organizationAdministrators", enableReinitialize: true })
)(Administrators);



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/Administrators.js